"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _AuthProvider = _interopRequireDefault(require("../../providers/AuthProvider"));

var _AuthMachine = _interopRequireDefault(require("../../machines/AuthMachine"));

var _Loading = _interopRequireDefault(require("../Loading"));

var _Button = _interopRequireDefault(require("../Button"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _naniClub = require("../../services/naniClub");

var _constants = require("../../constants");

var _NaniClubRedirect = require("./NaniClubRedirect.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Nani Club 登入落點頁
 *
 * 這頁只負責依登入狀態決定要去哪，以及在失敗時把訊息顯示出來。
 */
var NaniClubRedirect = function NaniClubRedirect() {
  var useAuthState = _AuthProvider.default.useAuthState;
  var AuthStates = _AuthMachine.default.state;
  var history = (0, _reactRouterDom.useHistory)();
  var authState = useAuthState();
  (0, _react.useEffect)(function () {
    if (authState.matches(AuthStates.LoginDone)) {
      history.replace("/");
      return;
    } // 新會員要先在 Login 頁面選學制


    if (authState.matches(AuthStates.ReadySettingEducation)) {
      history.replace(_constants.LOGIN_PATH);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [authState.value]);

  if (!authState.matches(AuthStates.Idle)) {
    return /*#__PURE__*/_react.default.createElement(_NaniClubRedirect.UiNaniClubRedirect, null, /*#__PURE__*/_react.default.createElement(_Loading.default, null));
  }

  return /*#__PURE__*/_react.default.createElement(_NaniClubRedirect.UiNaniClubRedirect, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "iconBox"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "cancel"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, "\u767B\u5165\u672A\u5B8C\u6210"), /*#__PURE__*/_react.default.createElement("div", {
    className: "message"
  }, authState.context.error || "登入失敗，請重新登入。"), /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "blue",
    onClick: function onClick() {
      return (0, _naniClub.redirectToLogin)(history);
    }
  }, "\u91CD\u65B0\u767B\u5165")));
};

var _default = NaniClubRedirect;
exports.default = _default;